export default "__VITE_ASSET__CYxTZ$i$__"